export { default } from './Tabs';
export { default as TabsContext } from './TabsContext';
export * from './TabsContext';
export { default as tabsClasses } from './tabsClasses';
export * from './tabsClasses';
export * from './Tabs.types';